import { FC } from 'react';

import TradePriceCache from '../../../../../lib/store-util/TradePriceCache';
import { formatCurrencyBySymbol } from '../../../../../lib/util/DataHelpers';
import { calculatePriceMovement } from '../../../../../lib/util/lastPriceChangeHelpers';

import { SymbolTableGrid } from '../../../../../components/SymbolTable/SymbolTableGrid.enum';
import SymbolTableRow from '../../../../../components/SymbolTable/SymbolTableRow/SymbolTableRow';
import useIsMobile from '../../../../hooks/useIsMobile';
import { EpicMoversInternalRowProps } from '../../EpicMoversInternal.types';

const EpicMoversInternalRow: FC<EpicMoversInternalRowProps> = ({ row, enableToggle, onSymbolClick }) => {
  const { isMobile } = useIsMobile();
  const { symbol, lookupSymbol, currencySymbol, isEuropeanSymbol, countryDesignation, displayName } = row;

  const { currentPrice, changePercent, change, direction } = TradePriceCache.use(lookupSymbol, 'EpicMoversInternalRow');
  const priceMovement = calculatePriceMovement(currentPrice, lookupSymbol);
  const currencyOptions = { countryDesignation, isEuropeanSymbol };

  // Ace's SymbolTableRow has no `enableToggle`, so it cannot be passed statically.
  // A JSX spread skips excess-property checking and compiles against both apps.
  const toggleProps = enableToggle ? { enableToggle: true } : {};

  return (
    <SymbolTableRow
      id={symbol}
      name={displayName}
      onRowClick={() => onSymbolClick(symbol)}
      oneRowInfoContent
      gridTemplateColumns={SymbolTableGrid.FOUR_ROW_ITEMS_GRID}
      {...toggleProps}
      model={{
        stock: row,
        chartSymbol: lookupSymbol,
        lastPrice: formatCurrencyBySymbol(currentPrice ?? row.price, currencySymbol, currencyOptions),
        // Only rendered on mobile, behind the toggle.
        changePrice: isMobile ? `${direction}${formatCurrencyBySymbol(change, currencySymbol, currencyOptions)}` : '',
        changePercent: `(${direction}${changePercent})`,
        direction,
        priceMovement,
      }}
    />
  );
};

export default EpicMoversInternalRow;
